import { baseURL, getIdToken } from "./client";

import axios from "axios";

// GET /api/v1/api-logs/search
// filters:
//   { clientUuid, q, limit, offset,
//     sinceDate (ISO string), untilDate (ISO string),
//     minStatus, maxStatus,
//     httpMethods (array of "GET" | "POST" | ...) }
// Any empty/undefined value is omitted from the query string.
// Response shape: { data: [...rows], total: N }
export const searchApiLogs = async (filters = {}) => {
  const {
    clientUuid,
    q,
    limit,
    offset,
    sinceDate,
    untilDate,
    minStatus,
    maxStatus,
    httpMethods,
    urlPath,
  } = filters;

  const params = {};
  if (clientUuid) params.clientUuid = clientUuid;
  if (q) params.q = q;
  if (limit) params.limit = limit;
  if (offset) params.offset = offset;
  if (sinceDate) params.sinceDate = sinceDate;
  if (untilDate) params.untilDate = untilDate;
  if (minStatus != null && minStatus !== "") params.minStatus = minStatus;
  if (maxStatus != null && maxStatus !== "") params.maxStatus = maxStatus;
  if (Array.isArray(httpMethods) && httpMethods.length > 0) {
    params.httpMethods = httpMethods.join(",");
  }
  if (urlPath && String(urlPath).trim()) {
    params.urlPath = String(urlPath).trim();
  }

  return axios({
    baseURL,
    url: "/api-logs/search",
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
    params,
  }).then(response => response.data);
};

// GET /api/v1/shipments/:waybill/api-timeline
export const getApiTimeline = async (waybill, { limit, clientUuid } = {}) => {
  const params = {};
  if (limit) params.limit = limit;
  if (clientUuid) params.clientUuid = clientUuid;

  return axios({
    baseURL,
    url: `/shipments/${encodeURIComponent(waybill)}/api-timeline`,
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
    params,
  }).then(response => response.data);
};
